/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable,Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, defer } from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { PopupService } from './services/popup.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  token!: string;

  constructor(private _auth:AuthService,private _pop:PopupService,@Inject(PLATFORM_ID) private platformId: object) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // return next.handle(request).pipe( tap(() => {
    //   // console.log('Request sent:', request);
    // },
    //   (err: any) => {
    //   if (err instanceof HttpErrorResponse) {
    //     if (err.status == 401) {
            
    //        this._auth.onLogout();
    //     //  return;
    //     }
    //   }
    // }));
    let startTime: number;
    if (isPlatformBrowser(this.platformId)) {
       startTime = performance.now();
    }
    return defer(() => {
      return next.handle(request).pipe(
        tap(() => {
          // Your logic here if you want to do something on success
        }),
        finalize(() => {
          if (isPlatformBrowser(this.platformId)) {
            const endTime = performance.now();
            const delay = endTime - startTime;
            const thresholdDelay = 200;
            if (delay > thresholdDelay) {
              // this.showPopup();
            }
          }
        })
      );
    }).pipe(
      tap(
        () => {
          // console.log('Request sent:', request);
        },
        (err: any) => {
          console.log('Request sent:', err);
          if (err instanceof HttpErrorResponse) {
            console.log('--------------------------- Request sent:', err.status);
            if (err.status == 403) {
              this._auth.onLogout();
              //  return;
            }
          }
        }
      )
    );
  }

  showPopup(){
    this._pop.showResponseDelay=true
  }
}